// import React, { useState, useEffect } from 'react';
// import { Link } from 'lucide-react';
// import {
//   fetchAvailableBuilds,
//   generateSingleLink,
// } from './api';

// import SingleLinkForm from './SingleLinkForm';
// import GeneratedLinkCard from './GeneratedLinkCard';

// const PresignLinkGenerator = () => {
//   const [loading, setLoading] = useState(false);
//   const [availableBuilds, setAvailableBuilds] = useState({});
//   const [generatedLink, setGeneratedLink] = useState(null);
//   const [copied, setCopied] = useState(null);
//   const [message, setMessage] = useState(null); 
  

//   const [formData, setFormData] = useState({
//     build_id: '',
//     expiration_hours: 24,
//     user_email: '',
//     purpose: '',
//   });

//   useEffect(() => {
//     const loadBuilds = async () => {
//       const data = await fetchAvailableBuilds();
//       if (data.success) {
//         setAvailableBuilds(data.builds);
//         const firstBuildId = Object.keys(data.builds)[0];
//         setFormData((p) => ({ ...p, build_id: firstBuildId }));
//       }
//     };
//     loadBuilds();
//   }, []);

//   const handleSingleLink = async () => {
//   setLoading(true);
//   setMessage(null); // clear previous message

//   const data = await generateSingleLink(formData);

//   if (data.success) {
//     setGeneratedLink(data);
//     setMessage({
//       type: "success",
//       text: "Link generated successfully!",
//     });
//   } else {
//     setMessage({
//       type: "error",
//       text: data.error || "Failed to generate link.",
//     });
//   }

//   setLoading(false);
// };


//   const copyToClipboard = async (text, index = null) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       setCopied(index !== null ? `bulk-${index}` : 'single');
//       setTimeout(() => setCopied(null), 2000);
//     } catch {
//       // fallback
//     }
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
//       <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
//         <Link className="text-blue-600" />
//         Presign Link Generator
//       </h1>

//       <SingleLinkForm
//         formData={formData}
//         setFormData={setFormData}
//         availableBuilds={availableBuilds}
//         loading={loading}
//         onGenerate={handleSingleLink}
//       />

//       {generatedLink && (
//         <GeneratedLinkCard
//           generatedLink={generatedLink}
//           copied={copied}
//           copyToClipboard={copyToClipboard}
//         />
//       )}

//     </div>
//   );
// };

// export default PresignLinkGenerator;


import React, { useState, useEffect } from "react";
import { Link } from "lucide-react";
import { fetchTherapistBuilds, generateSingleLink } from "./api"; // ✅ updated import
import SingleLinkForm from "./SingleLinkForm";
import GeneratedLinkCard from "./GeneratedLinkCard";
import axios from 'axios';
import Env from '../../../runtimeEnv';

const PresignLinkGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [availableBuilds, setAvailableBuilds] = useState({});
  const [generatedLink, setGeneratedLink] = useState(null);
  const [copied, setCopied] = useState(null);
  const [message, setMessage] = useState(null);

  const [formData, setFormData] = useState({
    build_id: "",
    expiration_hours: 24,
    user_email: "",
    purpose: "",
  });

  useEffect(() => {
    const loadTherapistBuilds = async () => {
      const data = await fetchTherapistBuilds(); // ✅ fetch therapists + builds
      if (!data.success) {
        setMessage({ type: "error", text: "Unable to load therapists. Please reload to try again." });
        return;
      }
      if (data.success) {
        // Convert API array → object for dropdown
        const therapistMap = {};
        data.therapists.forEach((t) => {
          therapistMap[t.therapist_id] = {
            name: t.name,
            description: t.description,
            url: t.url,
          };
        });

        setAvailableBuilds(therapistMap);

        // Set first therapist as default
        const firstTherapistId = Object.keys(therapistMap)[0];
        setFormData((prev) => ({ ...prev, build_id: firstTherapistId }));
      }
    };

    loadTherapistBuilds();
  }, []);

  const handleSingleLink = async () => {
    const expirationHours = Number(formData.expiration_hours);
    if (!Number.isInteger(expirationHours) || expirationHours < 1 || expirationHours > 24) {
      setGeneratedLink(null);
      setMessage({
        type: "error",
        text: "Expiration must be between 1 and 24 hours.",
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    const data = await generateSingleLink(formData);

    if (data.success) {
      setGeneratedLink(data);
      setMessage({
        type: "success",
        text: "Link generated successfully!",
      });
    } else {
      setMessage({
        type: "error",
        text: data.error || "Failed to generate link.",
      });
    }

    setLoading(false);
  };

  const copyToClipboard = async (text, index = null) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(index !== null ? `bulk-${index}` : "single");
      setTimeout(() => setCopied(null), 2000);
    } catch {
      // Fallback for older browsers
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
        <Link className="text-blue-600" />
        Presign Link Generator
      </h1>

      <SingleLinkForm
        formData={formData}
        setFormData={setFormData}
        availableBuilds={availableBuilds}
        loading={loading}
        onGenerate={handleSingleLink}
      />

      {message && (
        <div
          className={`mt-4 rounded-lg px-4 py-3 text-sm font-medium ${
            message.type === "success"
              ? "bg-green-50 text-green-800"
              : "bg-red-50 text-red-800"
          }`}
        >
          {message.text}
        </div>
      )}

      {generatedLink && (
        <GeneratedLinkCard
          generatedLink={generatedLink}
          copied={copied}
          copyToClipboard={copyToClipboard}
        />
      )}
    </div>
  );
};

export default PresignLinkGenerator;